import { render } from "./AcquisitionUpdate.vue?vue&type=template&id=a76cfa4a&scoped=true"
import script from "./AcquisitionUpdate.vue?vue&type=script&lang=js"
export * from "./AcquisitionUpdate.vue?vue&type=script&lang=js"

import "./AcquisitionUpdate.vue?vue&type=style&index=0&id=a76cfa4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76cfa4a"]])

export default __exports__